<template>
    <div class="interactive-guide">
        <VTour
            ref="tour"
            name="tour"
            :steps="steps"
            :options="optionsCombined"
            :callbacks="{ onStop: onFinish }"
        >
            <template #default="tour">
                <template v-for="(step, index) of tour.steps" :key="index">
                    <transition name="fade" appear>
                        <VStep
                            v-if="tour.currentStep === index"
                            :step="step"
                            :previous-step="tour.previousStep"
                            :next-step="tour.nextStep"
                            :stop="tour.stop"
                            :is-first="tour.isFirst"
                            :is-last="tour.isLast"
                            :labels="tour.labels"
                            class="interactive-guide__step"
                            :class="getStepClass(step)"
                        >
                            <template #content>
                                <div>
                                    <div class="interactive-guide__head">
                                        <span class="interactive-guide__title">
                                            {{ step.title }}
                                        </span>
                                    </div>
                                    <div class="interactive-guide__content" v-html="step.content"></div>
                                </div>
                            </template>
                            <template #actions>
                                <div>
                                    <div class="interactive-guide__controls">
                                        <div
                                            v-if="tour.steps.length < 6"
                                            class="interactive-guide__dots"
                                        >
                                            <div
                                                v-for="(n, i) in tour.steps.length"
                                                :key="n"
                                                class="interactive-guide__dot"
                                                :class="{ 'is-active': i == index }"
                                            ></div>
                                        </div>
                                        <div v-else class="interactive-guide__dots">
                                            <div class="interactive-guide__progress">
                                                {{ index }} {{ $t('tutorial.of') }}
                                                {{ tour.steps.length }}
                                            </div>
                                        </div>
                                        <div class="interactive-guide__buttons">
                                            <button
                                                v-if="index > 0"
                                                class="button interactive-guide__button interactive-guide__button--prev"
                                                type="button"
                                                @click="tour.previousStep"
                                            >
                                                {{ optionsCombined.labels.buttonPrevious }}
                                            </button>
                                            <button
                                                v-if="index >= 0 && index < tour.steps.length - 1"
                                                class="button interactive-guide__button"
                                                type="button"
                                                @click="tour.nextStep"
                                            >
                                                {{ optionsCombined.labels.buttonNext }}
                                            </button>
                                            <button
                                                v-if="index === tour.steps.length - 1"
                                                class="button interactive-guide__button"
                                                type="button"
                                                @click="tour.stop"
                                            >
                                                {{ optionsCombined.labels.buttonStop }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </VStep>
                    </transition>
                </template>
            </template>
        </VTour>
    </div>
</template>

<script>
import VStep from './VTour/VStep';
import VTour from './VTour/VTour';

export default {
    name: 'InteractiveGuide',
    components: {
        VTour,
        VStep,
    },
    props: {
        steps: {
            required: true,
            type: Array,
        },
        options: {
            type: Object,
            default: () => {},
        },
        // name for saving to localstorage
        name: {
            type: String,
            required: true,
        },
    },
    computed: {
        optionsCombined() {
            return {
                labels: {
                    buttonSkip: this.$t('tutorial.skip'),
                    buttonPrevious: this.$t('tutorial.prev'),
                    buttonNext: this.$t('tutorial.next'),
                    buttonStop: this.$t('tutorial.finish'),
                },
                startTimeout: 1000,
                ...this.options,
            };
        },
        localStorageKey() {
            return `sp-tutorial-${this.name}`;
        },
    },
    methods: {
        start() {
            this.$refs.tour.start();
        },
        checkAndRun() {
            let done = localStorage.getItem(this.localStorageKey);

            if (done) return;

            this.start();
        },
        onFinish() {
            localStorage.setItem(this.localStorageKey, true);
            this.$emit('tutorialFinished');
        },
        getStepClass(step) {
            let placement = 'bottom';

            if (step.params && step.params.placement) {
                placement = step.params.placement;
            }

            return `interactive-guide__step--${placement}`;
        },
    },
};
</script>

<style lang="scss" src="./InteractiveGuide.scss"></style>
